import { createSlice } from "@reduxjs/toolkit";
const initialState ={
    modalShow : false,
    modalModifShow : false,
    list :[],
    ajoutOk : false,
    modifOk : false,
    current :[],
}
const Fournisseurs = createSlice({
    name : 'FournisseursData',
    initialState,
    reducers :{
        showmodal:(state,action) =>{
            state.modalShow=action.payload
        },
        getList:(state,action) =>{
            state.list=action.payload
        },
        current:(state,action) =>{
            state.current=action.payload
        },
        ajout:(state,action) =>{
            state.ajoutOk=action.payload
    },
        modif:(state,action) =>{
        state.modifOk=action.payload
},
        addOne:(state,action) =>{
            state.list.push(action.payload)
    },
        modalModifShow:(state,action) =>{
            state.modalModifShow=action.payload
},
    update: (state, action) => {

        const element = state.list.find(element => element._id === action.payload.idfournisseur);
        if (element) {
            element.designation = action.payload.designation;
            element.tel = action.payload.tel;
            element.compte = action.payload.compte;
            element.adresse = action.payload.adresse;
            element.email = action.payload.email;
    }
  },
  remove: (state, action) => {    
    const id = action.payload;
    state.list=state.list.filter(element => element._id !== id);
  }

    }
})
export const {showmodal,getList,ajout,modif,addOne,modalModifShow,update,current,remove} = Fournisseurs.actions
export default Fournisseurs.reducer;